import { assertIsSetParam, } from './EquipmentServiceDriver';
import { ConfigKeyedValueBridge } from './ValueBridge';
export class ContactClosureBridge extends ConfigKeyedValueBridge {
    constructor(state, control, config, controlInfo, powerState, transport, valueCallback, log) {
        super('contactClosure', state, control, 'contactClosures', config, controlInfo, powerState, transport, valueCallback, log);
        assertIsSetParam(this.name);
        this.checkForDuplicates = false;
    }
    convertFromParam(value) {
        return { key: value.contactClosureId, value: value.value };
    }
    convertToParam(key, value) {
        return { contactClosureId: key, value };
    }
    getInfo(config) {
        return undefined;
    }
    setFilter(param, value, compParam, compValue) {
        if (param !== compParam)
            return true;
        const contactClosureId = value.contactClosureId;
        const compContactClosureId = compValue.contactClosureId;
        return contactClosureId !== compContactClosureId;
    }
}
